import React, { useState, useRef, useEffect } from "react"
import { expandElement, collapseElement } from "utils/expandable"
import { Container, Content, Top, Arrow, List, ReadMore } from "./styles"

const ClassModule = ({ lessons, title, description, dataId }) => {
  const [expanded, setExpanded] = useState(false)
  const ref = useRef(null)

  // initially collapsed
  useEffect(() => {
    collapseElement(ref, "25rem")
  }, [ref])

  return (
    <Container
      data-exp-id={dataId}
      onClick={() => {
        if (expanded) collapseElement(ref, "25rem")
        else expandElement(ref)
        setExpanded(!expanded)
      }}
    >
      <Content ref={ref}>
        <Top>
          <div>{lessons.length} lessons</div>
          <Arrow expanded={expanded} />
        </Top>
        <h3>{title}</h3>
        <div dangerouslySetInnerHTML={{ __html: description }} />
        <List>
          {lessons.map((lsn, idx) => (
            <li key={lsn}>
              {idx + 1}. {lsn}
            </li>
          ))}
        </List>
        <p>&nbsp;</p>
      </Content>
      <ReadMore expanded={expanded}>{expanded ? "Read less" : "Read more"}</ReadMore>
    </Container>
  )
}

export default ClassModule
